var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-tip"},[(_vm.showIcon)?_c('common-icon',{attrs:{"name":"info","size":"large"}}):_vm._e(),_vm._t("content"),_c('div',{ref:"tipContent",class:_vm.infoTipBulbClass},[_c('div',{staticClass:"info-tip__content"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.content))]})],2)])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }